import { useEffect, useState } from 'react';

const TICK_MS = 1000;

/**
 * Seconds left until `deadlineAt`, on the server's clock. `offsetMs` is how far this
 * device's clock is behind the server's, measured when the reply arrived — so a phone
 * set to the wrong time still counts down correctly. The server decides when time is
 * up either way.
 */
export function useCountdown(deadlineAt: string | null, offsetMs: number): number | null {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!deadlineAt) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), TICK_MS);
    return () => window.clearInterval(timer);
  }, [deadlineAt]);
  if (!deadlineAt) return null;
  return Math.max(0, Math.ceil((Date.parse(deadlineAt) - (now + offsetMs)) / 1000));
}

/** `m:ss`, or `h:mm:ss` for a section over an hour. */
export function formatClock(seconds: number): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const pad = (value: number): string => String(value).padStart(2, '0');
  return hours > 0 ? `${hours}:${pad(minutes)}:${pad(secs)}` : `${minutes}:${pad(secs)}`;
}
